import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Box, Spacer, Spinner, Text, VStack, useMediaQuery } from "native-base";
import CommonHeading from "../../../components/headings";
import ToggleButton from "../../../components/toggle";
import Events from "../../../containers/events";
import ContainerCards from "../../../components/cards";
import { COLORS } from "../../../utils/colors";
import { MOBILE_VIEW_WIDTH } from "../../../utils/screens";
import NoDataFound from "../../../components/noDataFound";
import CustomButton from "../../../components/button";
import { useSelector } from "react-redux";
import { getDeletedEventsAPI } from "../../../api/apis/quicklinks";
import { hasPermission } from "../../../utils/permission";

const LandingPageEvents = ({
  pagination,
  currentPage,
  setCurrentPage,
  events,
  getEventList,
  workflow,
  setActiveButton,
  setEvents,
  loaded = false,
}) => {
  const [tabActiveButton, setTabActiveButton] = useState("Upcoming");
  const options = hasPermission("ADMIN") ? ["Upcoming", "Past", "Deleted"] : ["Upcoming", "Past"];
  const [MobileWindow] = useMediaQuery({
    maxWidth: MOBILE_VIEW_WIDTH,
  });
  const [items, setItems] = useState([]);
  const [deletedEvents, setDeletedEvents] = useState([]);
  const [isLoadingDeleted, setIsLoadingDeleted] = useState(false);
  const [deletedPagination, setDeletedPagination] = useState(0);
  const [deletedCurrentPage, setDeletedCurrentPage] = useState(1);
  const activeTab = useSelector((state) => {
    return state.event.activeTab;
  });
  const [eventActiveTab, setEventActiveTab] = useState("");

  useEffect(() => {
    setItems(events);
    setEventActiveTab(activeTab === "event" ? "Events" : "MICE");
  }, [events, activeTab]);

  // Refetch deleted events when active tab changes and we're on deleted tab
  useEffect(() => {
    if (tabActiveButton === "Deleted") {
      setCurrentPage(1);
      fetchDeletedEvents(1, false);
    }
  }, [activeTab]);

  const fetchData = async (e) => {
    e.preventDefault();
    const response = await getEventList(
      tabActiveButton.toLowerCase(),
      currentPage,
      10,
      "",
      false
    );
    const scrollTop = window.scrollY + 10;
    window.scrollTo(0, scrollTop);
  };

  const fetchDeletedData = async (e) => {
    e.preventDefault();
    const nextPage = deletedCurrentPage + 1;
    await fetchDeletedEvents(nextPage, true);
    const scrollTop = window.scrollY + 10;
    window.scrollTo(0, scrollTop);
  };

  const fetchDeletedEvents = async (page = 1, append = false) => {
    try {
      setIsLoadingDeleted(true);
      const type = activeTab === "event" ? "event" : "mice";
      const response = await getDeletedEventsAPI(type, page, 10);
      
      if (response && response.data && response.data.data.data && Array.isArray(response.data.data.data)) {
        if (append) {
          setDeletedEvents(prev => [...prev, ...response.data.data.data]);
        } else {
          setDeletedEvents(response.data.data.data);
        }
        setDeletedPagination(response.data.data.pagination?.total || 0);
        setDeletedCurrentPage(page);
      } else {
        if (!append) {
          setDeletedEvents([]);
        }
      }
    } catch (error) {
      console.error("Error fetching deleted events:", error);
      if (!append) {
        setDeletedEvents([]);
      }
    } finally {
      setIsLoadingDeleted(false);
    }
  };

  return (
    <>
      <>
        <CommonHeading text={eventActiveTab} />
        <VStack space={5} mt={2}>
          <ToggleButton
            options={options}
            activeButton={tabActiveButton}
            setActiveButton={(value) => {
              setCurrentPage(1);
              setEvents([]);
              if (value === "Upcoming") {
                setActiveButton("upcoming");
                getEventList("upcoming", 1, 10, "", true);
              } else if (value === "Past") {
                setActiveButton("past");
                getEventList("past", 1, 10, "", true);
              } else if (value === "Deleted") {
                setActiveButton("deleted");
                fetchDeletedEvents(1, false);
              }
              setTabActiveButton(value);
            }}
          />
          {loaded || isLoadingDeleted ? (
            <Box mt={10} flex={1} alignItems="center" justifyContent="center">
              <Spinner color={COLORS.THEME_COLOR} size="lg" />
            </Box>
          ) : (
            <>
              <VStack space={4}>
                {tabActiveButton === "Deleted" ? (
                  Array.isArray(deletedEvents) && deletedEvents.length > 0 ? (
                    deletedEvents.map((item) => {
                      let event_date = item.deleted_at;
                      const dateObj = new Date(event_date);
                      const options = { month: "short" };
                      const month = dateObj.toLocaleDateString("en-US", options);
                      const day = dateObj.getDate();
                      let review = item?.average_rating
                        ? parseFloat(item?.average_rating.toFixed(1))
                        : 0;

                      return MobileWindow ? (
                        <Link
                          style={{ textDecoration: "none" }}
                          to={"/event-detail"}
                        >
                          <ContainerCards
                            width="100%"
                            height={"auto"}
                            minH="113px"
                            background={COLORS.WHITE_COLOR}
                            justifyContent="center"
                          >
                            <Events
                              events={item}
                              eventDate={day}
                              eventMonth={month}
                              eventName={item.event_name}
                              images={item?.deleted_counts?.images || 0}
                              ratings={review}
                              status="deleted"
                              deletedBy={item.deleted_by}
                              coordinatorName={item.coordinator_name}
                              onEventDeleted={() => {
                                fetchDeletedEvents(1, false);
                              }}
                            />
                          </ContainerCards>
                        </Link>
                      ) : (
                        <ContainerCards
                          width="100%"
                          height={"auto"}
                          minH="113px"
                          background={COLORS.WHITE_COLOR}
                          justifyContent="center"
                        >
                          <Events
                            events={item}
                            eventDate={day}
                            eventMonth={month}
                            eventName={item.event_name}
                            images={item?.deleted_counts?.images || 0}
                            ratings={review}
                            status="deleted"
                            deletedBy={item.deleted_by}
                            coordinatorName={item.coordinator_name}
                            onEventDeleted={() => {
                              fetchDeletedEvents(1, false);
                            }}
                          />
                        </ContainerCards>
                      );
                    })
                  ) : (
                    <NoDataFound
                      dataName="deleted data"
                      events={true}
                    />
                  )
                ) : items && items.length > 0 ? (
                  items.map((item) => {
                    let event_date = item.from_date;
                    const dateObj = new Date(event_date);
                    const options = { month: "short" };
                    const month = dateObj.toLocaleDateString("en-US", options);
                    const day = dateObj.getDate();
                    let review = item?.average_rating
                      ? parseFloat(item?.average_rating.toFixed(1))
                      : 0;

                    return MobileWindow ? (
                      <Link
                        style={{ textDecoration: "none" }}
                        to={"/event-detail"}
                      >
                        <ContainerCards
                          width="100%"
                          height={"auto"}
                          minH="113px"
                          background={COLORS.WHITE_COLOR}
                          justifyContent="center"
                        >
                          <Events
                            events={item}
                            eventDate={day}
                            eventMonth={month}
                            eventName={item.event_name}
                            images={item?.image_count}
                            ratings={review}
                            status={item.status}
                            onEventDeleted={() => {
                              if (tabActiveButton === "Upcoming") {
                                getEventList("upcoming", 1, 10, "", true);
                              } else {
                                getEventList("past", 1, 10, "", true);
                              }
                            }}
                          />
                        </ContainerCards>
                      </Link>
                    ) : (
                      <ContainerCards
                        width="100%"
                        height={"auto"}
                        minH="113px"
                        background={COLORS.WHITE_COLOR}
                        justifyContent="center"
                      >
                        <Events
                          events={item}
                          eventDate={day}
                          eventMonth={month}
                          eventName={item.event_name}
                          images={item?.image_count}
                          ratings={review}
                          status={item.status}
                          onEventDeleted={() => {
                            if (tabActiveButton === "Upcoming") {
                              getEventList("upcoming", 1, 10, "", true);
                            } else {
                              getEventList("past", 1, 10, "", true);
                            }
                          }}
                        />
                      </ContainerCards>
                    );
                  })
                ) : (
                  <NoDataFound
                    dataName={
                      eventActiveTab === "Events" ? "event" : eventActiveTab
                    }
                    events={true}
                  />
                )}
              </VStack>
            </>
          )}
        </VStack>
      </>

      <Box mt={4} alignItems="center" justifyContent="center">
        {tabActiveButton === "Deleted" ? (
          deletedEvents &&
          deletedEvents.length > 0 &&
          !isNaN(deletedPagination) &&
          deletedPagination > deletedEvents?.length && (
            <CustomButton text="Load More" onPress={fetchDeletedData} />
          )
        ) : (
          items &&
          items.length > 0 &&
          !isNaN(pagination) &&
          pagination > items.length && (
            <CustomButton text="Load More" onPress={fetchData} />
          )
        )}
      </Box>
    </>
  );
};

export default LandingPageEvents;
